import React from 'react';

export const Email = React.memo(({ fill }) => (
  <>
    <path
      d='M6 8.88878C6 8.50569 6.15218 8.13829 6.42307 7.8674C6.69395 7.59652 7.06135 7.44434 7.44444 7.44434H17.5556C17.9386 7.44434 18.306 7.59652 18.5769 7.8674C18.8478 8.13829 19 8.50569 19 8.88878V16.111C19 16.4941 18.8478 16.8615 18.5769 17.1324C18.306 17.4033 17.9386 17.5554 17.5556 17.5554H7.44444C7.06135 17.5554 6.69395 17.4033 6.42307 17.1324C6.15218 16.8615 6 16.4941 6 16.111V8.88878Z'
      stroke={fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6 8.88916L12.5 13.2225L19 8.88916'
      stroke={fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </>
));
Email.displayName = 'Email';
